import { getConfigValue } from 'utils/environment';
import { PaymentISOs } from 'utils/form/constants';

import { getGooglePayGateway, getGooglePayMerchantId } from './utils/get-google-configs';

export enum TransactionType {
  PAYMENT = 'payment',
  PREPAID = 'prepaid',
}

interface IgetGooglePaymentsConfigs {
  transactionType: TransactionType;
  countryCode: PaymentISOs;
  overrideMerchantId?: string;
  isDigitalWalletMigrationEnabled?: boolean;
}

/**
 * This function return the Google Pay transaction configs based on the transaction type and countrycode
 * It is returning the gateway and the gateway merchant id
 */
export const getGooglePaymentsConfigs = ({
  transactionType,
  countryCode,
  overrideMerchantId,
  isDigitalWalletMigrationEnabled,
}: IgetGooglePaymentsConfigs) => {
  // Checking if it's a prepaid or a payment transaction
  const isPayment = transactionType === TransactionType.PAYMENT;
  // Getting the right gateway based on the transaction type
  const googleConfig = getConfigValue('google');
  const gateway = getGooglePayGateway(
    googleConfig.paymentsGateway,
    googleConfig.prepaidPaymentsGateway,
    googleConfig.migrationPaymentsGateway,
    googleConfig.migrationPrepaidPaymentsGateway,
    isPayment,
    isDigitalWalletMigrationEnabled
  );

  // Getting the right gateway merchant id based on the transaction type
  const {
    paymentsGatewayMerchantId: paymentsMerchantIdMap,
    migrationPaymentsGatewayMerchantId: migrationPaymentsMerchantIdMap,
  } = googleConfig;
  const prepaidPaymentsMerchantIdMap = googleConfig.prepaidPaymentsGatewayMerchantId;

  const gatewayMerchantId = getGooglePayMerchantId(
    paymentsMerchantIdMap,
    migrationPaymentsMerchantIdMap,
    prepaidPaymentsMerchantIdMap,
    countryCode,
    isPayment,
    isDigitalWalletMigrationEnabled,
    overrideMerchantId
  );
  // Returning the right conf
  return { gateway, gatewayMerchantId };
};
